import { createReducer, on } from '@ngrx/store';

import { DiscussionModel } from '../../models/discussion.models';
import { DiscussionFormComponentActions, DiscussionFormEffectsActions } from '../actions';

export interface FormState {
  discussion: DiscussionModel | null;
  loading: boolean;
  saving: boolean;
}

export const InitialFormState: FormState = {
  discussion: null,
  loading: false,
  saving: false,
};

export const formReducer = createReducer<FormState>(
  InitialFormState,
  on(DiscussionFormEffectsActions.discussionRequested, (state): FormState => ({ ...state, loading: true })),

  on(
    DiscussionFormEffectsActions.discussionRequestSucceeded,
    DiscussionFormEffectsActions.discussionRequestFailed,
    (state): FormState => ({ ...state, loading: false })
  ),

  on(DiscussionFormEffectsActions.discussionRequestSucceeded, (state, { discussion }): FormState => ({
    ...state,
    discussion,
  })),

  on(DiscussionFormComponentActions.discussionFormSaved, (state): FormState => ({ ...state, saving: true })),

  on(
    DiscussionFormEffectsActions.discussionFormSaveSucceeded,
    DiscussionFormEffectsActions.discussionFormSaveFailed,
    (state): FormState => ({ ...state, saving: false })
  ),

  on(DiscussionFormComponentActions.discussionFormDestroyed, (): FormState => ({ ...InitialFormState }))
);
